import React, { useState } from 'react';

const SectionModal = ({ isOpen, section, onClose, onSave }) => {
  const [sectionData, setSectionData] = useState({ name: '', name_arabic: '' });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setSectionData(prevData => ({...prevData,  name: value }));
  };

  const handleArabicChange = (e) => {
    const value = e.target.value;
    setSectionData(prevData => ({ ...prevData, name_arabic: value }));
  };


  const handleSave = () => {
    const trimmedName = sectionData.name.trim();
    const trimmedNameArabic = sectionData.name_arabic.trim();

    if (trimmedName.length === 0 || trimmedNameArabic.length === 0) {
      setError('Section name cannot be empty.');
      return;
    }

    onSave({ name: trimmedName, name_arabic: trimmedNameArabic });
    setSectionData({ name: '', name_arabic: '' });
    setError('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[999]">
      <div className="bg-white p-6 rounded-lg w-full max-w-md">
        <h2 className="text-xl font-bold mb-4 text-amber-900">
          {section?.id ? 'Edit Section' : 'Add New Section'}
        </h2>

        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Section Name</label>
          <input
            type="text"
            className="w-full p-2 border border-gray-300 rounded"
            autoFocus
            placeholder="Enter section name"
            value={sectionData.name}
            onChange={handleChange}
          />
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 mb-2">Section Name (arabic)</label>
          <input
            type="text"
            className="w-full p-2 border border-gray-300 rounded"
            placeholder="Enter section name in arabic"
            value={sectionData.name_arabic}
            onChange={handleArabicChange}
          />
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>

        <div className="flex justify-end gap-3">
          <button
            className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-100"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-gold-dark disabled:bg-gold-dark/70 disabled:cursor-not-allowed text-white rounded cursor-pointer hover:bg-gold"
            onClick={handleSave}
            disabled={sectionData.name?.trim() === '' && sectionData.name_arabic?.trim() === ''}
          >
            {section?.id ? 'Save Changes' : 'Add Section'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SectionModal;
